import * as Ajax from './../analytics_dashboard/services';
import * as ModelCreators from './model_creators';

const Docs = function(dateParams) {
  var dfd = $.Deferred();

  $.when(
    Ajax.WorksService(),
    Ajax.HitsService(dateParams),
    Ajax.AllTimeHitsByCountryService(),
    Ajax.DownloadsService(dateParams),
    Ajax.PercentilesService()
  ).done(function(worksResponse, hitsResponse, allTimeHitsByCountryResponse, downloadResponse, percentilesResponse) {
    dfd.resolve(ModelCreators.Docs(
      worksResponse[0].works,
      hitsResponse[0].hits,
      allTimeHitsByCountryResponse[0].countries.by_work,
      downloadResponse[0].downloads,
      percentilesResponse[0].percentiles
    ));
  }).fail(dfd.reject);

  return dfd;
};


export {Docs};

// Aedu.ModelFetchers = {
//   Docs: Docs
// };
